import qcAtkingCityIdsStore from "../store/qcAtkingCityIds";

const useQcAtkingCityIds = (playerId) => {
    const atkingCityIds = qcAtkingCityIdsStore((state) => state.cityIds);
    const setAtkingCityId = qcAtkingCityIdsStore((state) => state.setCityId);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        playerAtkingCityId: playerId == null ? 0 : atkingCityIds[playerId] ?? 0,
        atkingCityIds,
        setAtkingCityId
    };
};

export default useQcAtkingCityIds;
